import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import orderBy from "lodash/fp/orderBy";
import classNames from "components/ui/classNames";

interface IIntangibleAssetsListProps {
  intangibleAssets: IBrazilianCompanyIssuerTopLevelFragment["intangibleAssets"];
}

export default function IntangibleAssetsList({ intangibleAssets }: IIntangibleAssetsListProps) {
  return (
    <div className="overflow-hidden rounded bg-white p-2">
      <table className="min-w-full border-collapse border-inherit text-left indent-0 text-sm tracking-wide">
        <thead className="bg-white">
          <tr>
            <th className="px-4 py-3 font-semibold uppercase text-neutral-700">Descrição do Ativo</th>
            <th className="px-4 py-3 font-semibold uppercase text-neutral-700">Tipo</th>
          </tr>
        </thead>

        <tbody>
          {orderBy(["type", "description"], ["asc", "asc"], intangibleAssets).map((node, index) => {
            return (
              <tr
                key={`${node.description}/${String(index)}`}
                className={classNames(
                  "group border-t border-neutral-200",
                  "hover:border-t-transparent [&:hover+tr]:border-t-transparent",
                )}
              >
                <td
                  className={classNames(
                    "px-4 py-3 group-hover:bg-neutral-50",
                    "group-hover:first-of-type:rounded-l-md group-hover:last-of-type:rounded-r-md",
                  )}
                >
                  <div>
                    <span className="text-base font-medium text-slate-600">{node.description}</span>
                  </div>

                  <div>
                    <span className="text-sm tracking-wider text-slate-500">Duração: {node.term}</span>
                  </div>
                </td>
                <td
                  className={classNames(
                    "px-4 py-3 group-hover:bg-neutral-50",
                    "group-hover:first-of-type:rounded-l-md group-hover:last-of-type:rounded-r-md",
                  )}
                >
                  {node.type}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
